import { FilterIcon } from '@panwds/icons';
import { Button, LoadingIcon } from '@panwds/react-ui';
import { classNames } from '@panwds/tailwindcss';
import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';

const AddButton = forwardRef(({ disabled, isLoading, showLabel = false, dataMetrics, dataTestId, isOpen, addFilterLabel, ...rest }, ref) => {
    const intl = useIntl();
    const textClasses = classNames(isLoading
        ? 'tw-text-default dark:tw-text-dark-bg'
        : disabled
            ? 'tw-text-disabled dark:tw-text-dark-bg-disabled tw-cursor-not-allowed'
            : 'tw-text-link dark:tw-text-blue-400');
    const label = disabled
        ? intl.formatMessage({
            defaultMessage: 'Filters are disabled',
            id: '+0hcL4',
            description: 'Filters are read only and cannot be interacted with'
        })
        : addFilterLabel ||
            intl.formatMessage({
                defaultMessage: 'Add Filter',
                id: 'GVFFft',
                description: 'Label on a button to add new filter'
            });
    const AddIcon = () => (React.createElement("span", { className: "tw-mr-2 tw-mt-1" },
        React.createElement(FilterIcon, { size: "sm" })));
    if (showLabel || isLoading) {
        return (React.createElement(Button, { ref: ref, ...rest, icon: React.createElement(AddIcon, null), appearance: "clear", disabled: disabled, "data-metrics": `${dataMetrics}`, "data-testid": dataTestId || 'button-add-filter' },
            React.createElement("span", { className: classNames('tw-flex tw-items-center', textClasses) }, isLoading ? (React.createElement(React.Fragment, null,
                React.createElement(LoadingIcon, { size: "lg", className: "tw-mr-2 tw-animate-spin" }),
                intl.formatMessage({
                    defaultMessage: 'Loading',
                    id: 'VHbZhY',
                    description: 'Displayed while filter bar is loading'
                }))) : (label))));
    }
    return (React.createElement("span", { ref: ref, ...rest },
        React.createElement(Button, { "aria-label": label, icon: React.createElement(AddIcon, null), appearance: "clear", disabled: disabled, "data-testid": dataTestId || 'add-filter', "data-metrics": `${dataMetrics}` }, addFilterLabel ||
            intl.formatMessage({
                defaultMessage: 'Add Filter',
                id: 'TA7r+x',
                description: 'Add a new filter to the filter bar'
            }))));
});
AddButton.displayName = 'AddButton';

export { AddButton };
//# sourceMappingURL=AddButton.esm.js.map
